import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookieConsentService } from 'src/app/services';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        RouterLink,
        TranslateModule,
    ],
})
export class CookieComponent {
  cookieConsent: string | undefined;
  subscription: Subscription;

  constructor(private cookieConsentService: CookieConsentService) {
    this.cookieConsent = this.cookieConsentService.get();
    this.subscription = this.cookieConsentService.cookieConsentEmitter.subscribe(el => this.cookieConsent = el);
  }

  setCookie(value: string) {
    this.cookieConsentService.set(value);
  }

}
